import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ProfileFields from './ProfileFields/ProfileFields';
import CustomFields from './CustomFields/CustomFields';

const IN = (props) => {
	const { t, i18n } = useTranslation();

	const {formFields, setFormFields, count, form_component} = props;
	const {funnel_page, profile_fields} = formFields;

	const [components, setComponents] = useState([]);

	return (
		<div className="quest mb-3 d-flex gap-3">
			{funnel_page.show_ques_num && (
				<div className="badge-circle badge-light-dark badge">{count}</div>
			)}
			{(() => {
				switch (form_component.type) {
					case 'CF':
					case 'SF':
						components.push(
							<ProfileFields
								key={`component-${count}`}
								lang={props.lang}
								formFields={formFields}
								count={count}
								form_component={form_component}
							/>
						);
						break;
					
					case 'CPF':
						for (let index = 0; index < profile_fields.length; index++) {
							const profile_field = profile_fields[index];
							if (profile_field.fieldname === form_component.fieldname) {
								const updatedFieldname = `profile_custom_fields[${form_component.fieldname}]`;
								form_component.fieldname = updatedFieldname;
								//console.log(`profile fieldname`, profile_field.fieldname, `form_component`, form_component);

								components.push(
									<CustomFields
										key={`component-${count}-${index}`}
										lang={props.lang}
										formFields={formFields}
										count={count}
										form_component={form_component}
									/>
								);

								break; // Breaks out of the for loop
							}
						}
						break;

					case 'PCU':
						components.push(
							<CustomFields
								key={`component-${count}`}
								lang={props.lang}
								formFields={formFields}
								count={count}
								form_component={form_component}
							/>
						);
						break;
				}

				//console.log(`final components`, components);

				return components;
			})()}
		</div>
	);
}

export default IN;